module.exports = __webpack_public_path__ + "img/numeralia_cedis_2.4a33e31f.svg";